import React, { useState } from "react";

export default function CustomerDetailModule({tab, setTab}: {tab: string, setTab: (tab: string) => void}) {
  const customer = {
    id: "CUST-001",
    name: "Ola Normann ",
    email: "ola@chamcore.com",
    phone: "+47 96702167",
    status: "active" as "active" | "inactive",
    totalSpentNok: 9245,
    totalMinutes: 121,
    lastActive: "I dag 13:02",
    country: "Norge",
    city: "Oslo",
    zip: "0563",
    address: "Hovedgata 21A",
    paymentMethods: ["Vipps", "Stripe", "Wallet"],
  };

  const callHistory = [
    {
      id: "CALL-001",
      date: "25.11.2025",
      time: "13:02",
      advisor: "John Doe",
      lengthMinutes: 14,
      priceNok: 199,
      method: "Vipps",
      status: "fullført",
      paymentId: "vipps_tx_8237492",
    },
    {
      id: "CALL-002",
      date: "24.11.2025",
      time: "18:20",
      advisor: "Ingrid Hansen",
      lengthMinutes: 32,
      priceNok: 349,
      method: "Stripe",
      status: "fullført",
      paymentId: "ch_1QWEASD",
    },
    {
      id: "CALL-003",
      date: "23.11.2025",
      time: "09:15",
      advisor: "Per Johansen",
      lengthMinutes: 9,
      priceNok: 99,
      method: "Vipps",
      status: "fullført",
      paymentId: "vipps_tx_5566123",
    },
  ];

  const [otpSent, setOtpSent] = useState(false);
  const [selectedCall, setSelectedCall] = useState<null | (typeof callHistory)[number]>(null);
  const [methodFilter, setMethodFilter] = useState("all");
  const [advisorFilter, setAdvisorFilter] = useState("all");
  const [sortBy, setSortBy] = useState("date_desc");

  const filteredCalls = callHistory.filter((c) => {
    if (methodFilter !== "all" && c.method !== methodFilter) return false;
    if (advisorFilter !== "all" && c.advisor !== advisorFilter) return false;
    return true;
  });

  const sortedCalls = [...filteredCalls].sort((a, b) => {
    if (sortBy === "duration_desc") {
      return b.lengthMinutes - a.lengthMinutes;
    }
    if (sortBy === "amount_desc") {
      return b.priceNok - a.priceNok;
    }
    // date_desc – her kunne vi brukt faktisk datoobjekt, men mocker rekkefølgen som den er
    return 0;
  });

  const totalAmount = filteredCalls.reduce((sum, c) => sum + c.priceNok, 0);
  const totalMinutesCalls = filteredCalls.reduce((sum, c) => sum + c.lengthMinutes, 0);
  const methodTotals = filteredCalls.reduce<Record<string, number>>((acc, c) => {
    acc[c.method] = (acc[c.method] || 0) + c.priceNok;
    return acc;
  }, {});

  const exportCsv = () => {
    alert("Eksport til CSV – kobles mot backend senere.");
  };

  const exportPdf = () => {
    alert("Eksport til PDF – kobles mot backend senere.");
  };

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6 sm:px-8 sm:py-10">
      {/* TOP BAR */}
      <button
        className="mb-6 text-slate-500 hover:text-slate-900 text-sm"
        onClick={() => setTab("Kunder")}
      >
        ← Tilbake til kundeliste
      </button>

      {/* HEADER */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">
            {customer.name}
          </h1>
          <p className="text-sm text-slate-500">Kundedetaljer og administrasjon</p>
        </div>
        <span
          className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium border ${
            customer.status === "active"
              ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : "bg-slate-50 text-slate-500 border-slate-200"
          }`}
        >
          <span className="mr-1 h-1.5 w-1.5 rounded-full bg-current" />
          {customer.status === "active" ? "Aktiv" : "Inaktiv"}
        </span>
      </div>

      {/* KPI ROW */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <p className="text-[11px] uppercase text-slate-500">Akkumulert omsetning</p>
          <p className="text-2xl font-semibold text-slate-900 mt-1">
            {customer.totalSpentNok.toLocaleString("nb-NO")} NOK
          </p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <p className="text-[11px] uppercase text-slate-500">Total samtaletid</p>
          <p className="text-2xl font-semibold text-slate-900 mt-1">
            {customer.totalMinutes} min
          </p>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
          <p className="text-[11px] uppercase text-slate-500">Sist aktiv</p>
          <p className="text-lg font-semibold text-slate-900 mt-1">
            {customer.lastActive}
          </p>
        </div>
      </div>

      {/* INFO + ACTIONS GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* LEFT COLUMN */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col gap-4">
          <h2 className="text-lg font-semibold text-slate-900 mb-2">Kundeinformasjon</h2>
          <div className="text-sm text-slate-600 space-y-1">
            <p>
              <span className="font-medium text-slate-900">Kunde-ID:</span> {customer.id}
            </p>
            <p>
              <span className="font-medium text-slate-900">E-post:</span> {customer.email}
            </p>
            <p>
              <span className="font-medium text-slate-900">Telefon:</span> {customer.phone}
            </p>
            <p>
              <span className="font-medium text-slate-900">Adresse:</span> {customer.address}
            </p>
            <p>
              <span className="font-medium text-slate-900">Postkode:</span> {customer.zip}
            </p>
            <p>
              <span className="font-medium text-slate-900">By:</span> {customer.city}
            </p>
            <p>
              <span className="font-medium text-slate-900">Land:</span> {customer.country}
            </p>
          </div>
        </div>

        {/* PAYMENT + SUPPORT */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 flex flex-col gap-6">
          <div>
            <h2 className="text-lg font-semibold text-slate-900 mb-3">Betalingsmetoder</h2>
            <div className="flex flex-wrap gap-3">
              {customer.paymentMethods.map((m, i) => (
                <span
                  key={i}
                  className="px-3 py-1.5 rounded-full text-xs font-medium bg-slate-100 border border-slate-200 text-slate-700"
                >
                  {m}
                </span>
              ))}
            </div>
          </div>

          <div className="border-t border-slate-200 pt-4">
            <h2 className="text-lg font-semibold text-slate-900 mb-3">Supporthandlinger</h2>
            <div className="flex flex-col gap-3">
              <button
                className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm hover:bg-slate-800"
                onClick={() => setOtpSent(true)}
              >
                Send engangskode
              </button>
              <button className="px-4 py-2 rounded-lg bg-slate-100 border border-slate-300 text-sm hover:bg-slate-200">
                Send kvittering
              </button>
              <button className="px-4 py-2 rounded-lg bg-rose-600 text-white text-sm hover:bg-rose-700">
                Start refusjon
              </button>
            </div>

            {otpSent && (
              <p className="text-xs text-emerald-600 mt-2">Engangskode sendt!</p>
            )}
          </div>
        </div>

        {/* ACTIVITY LOG */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
          <h2 className="text-lg font-semibold text-slate-900 mb-3">Siste aktivitet</h2>
          <ul className="space-y-3 text-sm text-slate-700">
            <li>📞 Samtale – 14 min (I dag 13:02)</li>
            <li>🧾 Kjøp gjennomført – 199 NOK (I går 18:20)</li>
            <li>🔒 Logget inn (I går 09:15)</li>
          </ul>
        </div>
      </div>

      {/* ECON SUMMARY + EXPORT */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6 mb-6 flex flex-col lg:flex-row gap-6 lg:items-center lg:justify-between">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">
            Økonomisk oversikt (filtrert periode)
          </h2>
          <p className="text-sm text-slate-500 mb-3">
            Basert på samtalehistorikken under.
          </p>
          <div className="flex flex-wrap gap-4 text-sm">
            <div>
              <p className="text-slate-500">Antall samtaler</p>
              <p className="font-semibold text-slate-900">{filteredCalls.length}</p>
            </div>
            <div>
              <p className="text-slate-500">Total varighet</p>
              <p className="font-semibold text-slate-900">{totalMinutesCalls} min</p>
            </div>
            <div>
              <p className="text-slate-500">Total omsetning</p>
              <p className="font-semibold text-slate-900">
                {totalAmount.toLocaleString("nb-NO")} NOK
              </p>
            </div>
            <div>
              <p className="text-slate-500">Fordeling per betalingsmetode</p>
              <p className="font-semibold text-slate-900">
                {Object.keys(methodTotals).length === 0
                  ? "–"
                  : Object.entries(methodTotals)
                      .map(([method, amount]) => `${method}: ${amount.toLocaleString("nb-NO")} NOK`)
                      .join(" · ")}
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={exportCsv}
            className="px-4 py-2 rounded-lg border border-slate-300 bg-slate-50 text-sm font-medium text-slate-800 hover:bg-slate-100"
          >
            Eksporter CSV
          </button>
          <button
            onClick={exportPdf}
            className="px-4 py-2 rounded-lg bg-slate-900 text-sm font-medium text-white hover:bg-slate-800"
          >
            Eksporter PDF
          </button>
        </div>
      </div>

      {/* CALL HISTORY WITH FILTERS */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-4">
          <div>
            <h2 className="text-lg font-semibold text-slate-900 mb-1">
              Samtalehistorikk
            </h2>
            <p className="text-sm text-slate-500">
              Detaljert logg per samtale med rådgiver, pris og betalingsmåte.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 text-sm">
            <div>
              <label className="block text-xs text-slate-500 mb-1">Betalingsmåte</label>
              <select
                value={methodFilter}
                onChange={(e) => setMethodFilter(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="all">Alle</option>
                <option value="Vipps">Vipps</option>
                <option value="Stripe">Stripe</option>
              </select>
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Veileder</label>
              <select
                value={advisorFilter}
                onChange={(e) => setAdvisorFilter(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="all">Alle</option>
                <option value="Ola Nordmann">Ola Nordmann</option>
                <option value="Ingrid Hansen">Ingrid Hansen</option>
                <option value="Per Johansen">Per Johansen</option>
              </select>
            </div>
            <div>
              <label className="block text-xs text-slate-500 mb-1">Sorter</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm"
              >
                <option value="date_desc">Nyeste først</option>
                <option value="duration_desc">Lengst varighet</option>
                <option value="amount_desc">Høyest pris</option>
              </select>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b border-slate-200">
                <th className="py-2 pr-4">Dato</th>
                <th className="py-2 pr-4">Tid</th>
                <th className="py-2 pr-4">Veileder</th>
                <th className="py-2 pr-4">Lengde</th>
                <th className="py-2 pr-4">Pris</th>
                <th className="py-2 pr-4">Betaling</th>
                <th className="py-2">Detaljer</th>
              </tr>
            </thead>
            <tbody className="text-slate-700">
              {sortedCalls.map((call) => (
                <tr key={call.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="py-2 pr-4">{call.date}</td>
                  <td className="py-2 pr-4">{call.time}</td>
                  <td className="py-2 pr-4">{call.advisor}</td>
                  <td className="py-2 pr-4">{call.lengthMinutes} min</td>
                  <td className="py-2 pr-4">{call.priceNok.toLocaleString("nb-NO")} NOK</td>
                  <td className="py-2 pr-4">{call.method}</td>
                  <td className="py-2">
                    <button
                      className="text-xs font-medium text-violet-700 hover:text-violet-900"
                      onClick={() => setSelectedCall(call)}
                    >
                      Vis
                    </button>
                  </td>
                </tr>
              ))}
              {sortedCalls.length === 0 && (
                <tr>
                  <td colSpan={7} className="py-6 text-center text-sm text-slate-400">
                    Ingen samtaler matcher filtrene.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* CALL DETAIL MODAL */}
      {selectedCall && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 max-w-lg w-full mx-4 p-6">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  Samtaledetaljer
                </h3>
                <p className="text-xs text-slate-500">
                  {selectedCall.date} kl. {selectedCall.time} · {selectedCall.lengthMinutes} min med {selectedCall.advisor}
                </p>
              </div>
              <button
                onClick={() => setSelectedCall(null)}
                className="text-slate-400 hover:text-slate-600 text-lg"
              >
                ×
              </button>
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm mb-4">
              <div>
                <p className="text-slate-500">Pris</p>
                <p className="font-semibold text-slate-900">
                  {selectedCall.priceNok.toLocaleString("nb-NO")} NOK
                </p>
              </div>
              <div>
                <p className="text-slate-500">Betalingsmåte</p>
                <p className="font-semibold text-slate-900">{selectedCall.method}</p>
              </div>
              <div>
                <p className="text-slate-500">Veileder</p>
                <p className="font-semibold text-slate-900">{selectedCall.advisor}</p>
              </div>
              <div>
                <p className="text-slate-500">Betalingsreferanse</p>
                <p className="font-mono text-xs text-slate-900 break-all">
                  {selectedCall.paymentId}
                </p>
              </div>
            </div>

            <div className="border-t border-slate-200 pt-4 flex flex-wrap gap-3">
              <button className="px-4 py-2 rounded-lg bg-slate-900 text-white text-xs font-medium hover:bg-slate-800">
                Send kvittering for denne samtalen
              </button>
              <button className="px-4 py-2 rounded-lg bg-rose-600 text-white text-xs font-medium hover:bg-rose-700">
                Start refusjon på denne samtalen
              </button>
              <button className="px-4 py-2 rounded-lg border border-slate-300 bg-slate-50 text-xs font-medium text-slate-800 hover:bg-slate-100">
                Marker for intern gjennomgang
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
